import React from 'react';
import EmptyPage from '../jsx/components/Dashboard/EmptyPage';

const SuperAdminHome = () => {
  return <EmptyPage />;
};

export default SuperAdminHome;
